import React from "react";

import background from '@cover/kopfstandstarten/background-1.jpg';
import backgroundSm from '@cover/kopfstandstarten/background-1-sm.jpg';
import background2 from '@cover/kopfstandstarten/background-2.png';
import background2Sm from '@cover/kopfstandstarten/background-2-sm.png';
import background3 from '@cover/kopfstandstarten/background-3.png';
import background3Sm from '@cover/kopfstandstarten/background-3-sm.png';
import KopfstandStarten from "../components/cover/animations/kopfstandstarten";

import eyeSrc from '@assets/eye.svg';
import articleSrc from '@assets/article.svg';

export const meta = {
	category: "start",
	slug: "kopfstand",
	id: "KopfstandStarten",
	excerpt: {
		before: "Anders Indset ist Wirtschaftsphilosoph, Kolumnist und Autor des Sachbuchs „Wildes Wissen — Klarer denken als die Revolution erlaubt“. Der Norweger war im Jahr 2020 bei Mission M zu Gast, dem Kongress für junge Macherinnen und Macher im Mittelstand."
	},
	name: "kopfstandstarten",
	title: "Talking 'bout a revolution",
	animation: KopfstandStarten,
	cover: {
		background: {
			lg: background,
			sm: backgroundSm
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2Sm
				},
				zIndex: 666,
			},
			{
				src: {
					lg: background3,
					sm: background3Sm
				},
				zIndex: 999,
			}
		],
		alt: "Anders Indset wirkt ernst. Dennoch umgeben ihn Smileys und viele Hände, die seine Augen öffnen, bunte Linien malen und Herzchen formen."
	}
}

const KopfstandstartenArticle = () => {
	return (
		<div>
			<ol className="articleList articleList--ordered">
				<li className="articleListItem">Wir werden zunehmend zu dopamingesteuerten Junkies, die durch das Leben gezerrt werden. Wacht endlich auf aus eurem großen Nickerchen!</li>
				<li className="articleListItem">Lernt zu lernen mit Tiefgang und richtet Denkstunden ein! Starrt auf ein weißes Blatt Papier, bis euch das Blut aus den Augen tropft.</li>
				<li className="articleListItem">Verletzlichkeit ist der Geburtsort von Innovation und Kreation, Vertrauen und Beziehung. Der Kapitalismus von morgen braucht Mitgefühl und Liebe.</li>
			</ol>
			<p className="articleHint">
				Anders Indset ist Wirtschaftsphilosoph,
				Kolumnist und Autor des Sachbuchs
				„Wildes Wissen — Klarer denken als die
				Revolution erlaubt“. Der Norweger
				war im Jahr 2020 bei Mission M zu Gast,
				dem Kongress für junge Macherinnen
				und Macher im Mittelstand.
			</p>
			<a href="https://www.bwstiftung.de/de/magazin/perspektiven-01-2021/fu%CC%88hren-wollen-oder-loslassen-koennen" target="_blank" className="articleLink articleLink--block">
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					„Führen wollen – oder loslassen können?“
					<div className="articleLinkSource">
						Perspektiven-Magazin
					</div>
				</div>
			</a>
			<a href="https://www.bwstiftung.de/fileadmin/bw-stiftung/Publikationen/Perspektive/Perspektiven_Magazin_Mut_01_2021_BWS.pdf#page=12" target="_blank" className="articleLink articleLink--block">
			 <div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					Mut zu Veränderung: New Work
					<div className="articleLinkSource">
						Perspektiven 01/2021
					</div>
				</div>
			</a>
			<a href="https://www.youtube.com/watch?v=45SmRo8MCG0" target="_blank" className="articleLink articleLink--block">
			 <div className="articleLinkIcon">
					<img src={eyeSrc} />
				</div>
				<div>
					Mission M 2020 | Zukunft der Unternehmensführung | Anders Indset
					<div className="articleLinkSource">
						bwstiftung - YouTube
					</div>
				</div>
			</a>
		</div>
	)
};

export default KopfstandstartenArticle;